import React, { useContext, useEffect, useState } from "react";
import "./LoanDetailsMemberView.css";
import InputForm from "../../../Components/InputForm/InputForm";
import CanvasJSReact from "@canvasjs/react-charts";
import { useLocation, useSearchParams } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  GetLoanDetailsById,
  ReplaceSurety,
  getSuretyDetailsForApproval,
  CheckLoanRepaymentCriteria,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { IconButton, Tooltip, Typography } from "@mui/material";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { getFormattedCurrencyValue, sleep } from "../../../Helpers/Common";
import { LoanTypeEnum } from "../../../Helpers/Enums/Enum";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { useNavigate } from "react-router-dom";
import LoanSettlementTabs from "./LoanSettlementTabs";

const LoanDetailsMemberView = (props) => {
  const { state } = useLocation();
  const { LoanRequestId, LoanRepaymentId, Status, RepaymentAmount } = state;
  //const [searchParams, setSearchParams] = useSearchParams();
  //const Id = state?.Id; // || searchParams.get("id");
  //const isAL = searchParams.get("isAL") === "1";
  var CanvasJSChart = CanvasJSReact.CanvasJSChart;
  const context = getContext();
  let navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [showSuretyReplaceModal, setShowSuretyReplaceModal] =
    useState<boolean>(false);
  const [newSuretyMemberNo, setNewSuretyMemberNo] = useState<string>("");
  const [suretyForReplacement, setSuretyForReplacement] = useState<any>(null);
  const [key, setKey] = useState<number>(0);
  const [showGraph, setShowGraph] = useState<boolean>(false);
  const [showRepaymentModal, setRepaymentModal] = useState<boolean>(false);
  const [loanDetails, setLoanDetails] = useState({
    loanAmount: 0,
    additionalLoanAmount: 0,
    interestRate: 0,
    loanTenure: 0,
    loanEmi: 0,
    pendingMonths: 0,
    balanceAmount: 0,
    loanType: LoanTypeEnum.SHORTTERM,
    isSuretyReplaced: 0,
    ROI: 0,
    aROI: 0,
    emiAmountAL: 0,
    outstandingAmountAL: 0,
    pendingMonthsAL: 0,
    SpecialSanctionedAmount: 0,
  });
  const [, setSureties] = useState([]);
  const [error, setError] = React.useState<any>({});
  const [, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [, setStart] = useState(0);
  const [, setSortColumn] = useState("");
  const [, setSearchText] = useState("");
  const [dashboardData, setDashboardData] = useState([]);
  const [isSettlementButtonEnabled, setSettlementButtonEnabled] =
    useState<boolean>(false);

  enum EventTarget {}

  const options1 = {
    title: {
      text:
        "Total \n₹" +
        getFormattedCurrencyValue(
          loanDetails?.loanAmount + loanDetails?.SpecialSanctionedAmount
        ),
      verticalAlign: "center",
      dockInsidePlotArea: true,
      maxWidth: 90,
      wrap: true,
    },
    data: [
      {
        type: "doughnut",
        showInLegend: false,
        legendText: "{label}",
        startAngle: 90,
        toolTipContent: "{label}: <strong>₹{y}</strong>",
        indexLabel: "{label}: ₹{y}",
        indexLabelPlacement: "outside",
        indexLabelWrap: true,
        dataPoints: [
          {
            label: "Total Paid",
            y:
              loanDetails?.loanAmount +
                loanDetails?.SpecialSanctionedAmount -
                loanDetails?.balanceAmount || 0,
            color: "#88a825",
          },
          {
            label: "Balance Amount",
            y: loanDetails.balanceAmount,
            color: "#ed892b",
            exploded: true,
          },
          // { label: "Total Interest", y: 15.2, color: "Green", exploded: true },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    animationEnabled: true,
  };

  const options2 = {
    title: {
      text:
        "Total \n₹" +
        getFormattedCurrencyValue(loanDetails?.additionalLoanAmount),
      verticalAlign: "center",
      dockInsidePlotArea: true,
      maxWidth: 90,
      wrap: true,
    },
    data: [
      {
        type: "doughnut",
        showInLegend: false,
        legendText: "{label}",
        startAngle: 90,
        toolTipContent: "{label}: <strong>₹{y}</strong>",
        indexLabel: "{label}: ₹{y}",
        indexLabelPlacement: "outside",
        indexLabelWrap: true,
        dataPoints: [
          {
            label: "Total Paid",
            y:
              loanDetails?.additionalLoanAmount -
                loanDetails?.outstandingAmountAL || 0,
            color: "#88a825",
          },
          {
            label: "Balance Amount",
            y: loanDetails.outstandingAmountAL,
            color: "#ed892b",
            exploded: true,
          },
          // { label: "Total Interest", y: 15.2, color: "Green", exploded: true },
        ],
      },
    ],
    width: 350, // Set the width of the chart
    height: 250, // Set the height of the chart
    fontSize: 14, // Set the font size for the chart
    animationEnabled: true,
  };

  const getLoanDetails = async () => {
    showLoader();
    try {
      //await sleep(2500);
      const data = {
        Id: LoanRequestId,
      };

      const resp = await APICall(GetLoanDetailsById, data);

      if (resp.Status === ApiStatus.OK && resp?.Data) {
      
        const respData = resp?.Data;
        setLoanDetails({
          loanAmount: respData?.LoanAmount || 0,
          additionalLoanAmount: respData?.AdditionalLoanAmount || 0,
          interestRate: respData?.RateOfInterest || 0,
          loanTenure: respData?.InstallmentPeriod || 0,
          loanEmi: respData?.EmiAmount || 0,
          pendingMonths: respData?.PendingMonths || 0,
          balanceAmount: respData?.BalanceAmount || 0,
          loanType: respData?.LoanTypeId,
          isSuretyReplaced: respData?.IsSuretyReplaced || 0,
          ROI: respData?.ROI || 0,
          aROI: respData?.AROI || 0,
          emiAmountAL: respData?.EmiAmountAL || 0,
          outstandingAmountAL: respData?.OutstandingAmountAL || 0,
          pendingMonthsAL: respData?.PendingMonthsAL || 0,
          SpecialSanctionedAmount: respData?.SpecialSanctionedAmount || 0,
        });
        setTimeout(() => setShowGraph(true), 50);
      }
    } finally {
      hideLoader();
    }
  };

  const getSuretyDetails = async () => {
    showLoader();
    try {
      //await sleep(2500);
      const data = {
        LoanRequestId: LoanRequestId,
      };

      const resp = await APICall(getSuretyDetailsForApproval, data);

      if (resp.Status === ApiStatus.OK && resp?.Data?.length > 0) {
        setSureties(resp?.Data);
        setDashboardData(resp?.Data);
        setDataCount(resp?.Data?.length || 0);
      }
    } finally {
      hideLoader();
    }
  };

  const CheckRepaymentCriteria = async () => {
    showLoader();
    try {
      const data = {
        LoanRequestId: LoanRequestId,
      };

      const resp = await APICall(CheckLoanRepaymentCriteria, data);
      if (
        resp.Status === ApiStatus.OK &&
        resp?.Data?.hasOwnProperty("IsRepaymentAllowed")
      ) {
        setSettlementButtonEnabled(resp?.Data?.IsRepaymentAllowed);
      }
    } finally {
      hideLoader();
    }
  };

  const replaceSurety = async () => {
    showLoader();
    try {
      if (!newSuretyMemberNo) {
        let errorObj = {};
        errorObj = {
          ...errorObj,
          [newSuretyMemberNo]: "This field is required",
        };
        setError(errorObj);
        return;
      }
      const data = {
        LoanId: LoanRequestId,
        SuretyId: suretyForReplacement?.Lrs_Id,
        NewSurityMemberNo: newSuretyMemberNo,
        ModifiedBy: context?.Id,
      };
      const resp = await APICall(ReplaceSurety, data);

      if (resp.Status === ApiStatus.OK && resp?.Data) {
        notify(ToastType.Success, "Surety replaced successfully.");
        setShowSuretyReplaceModal(false);
        setSuretyForReplacement(null);
        setNewSuretyMemberNo("");
        getSuretyDetails();
      } else if (resp.Status === ApiStatus.Error && resp?.Message) {
        notify(ToastType.Error, resp?.Message);
      } else {
        notify(
          ToastType.Error,
          "Surety replacement failed. Please contact administrator"
        );
      }
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    sort: false,
    pagination: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "MemberNo",
      label: "Member No",
      options: CommonCellOptions(),
    },
    {
      name: "FullName",
      label: "Member Name",
      options: CommonCellOptions(),
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          const rowIndex = tableMeta.rowIndex;
          let surety = dashboardData[rowIndex];
          debugger;
          return (
            <>
              <Tooltip title="replace">
                <IconButton
                  aria-label="delete"
                  size="small"
                  color="info"
                  disabled={!surety?.IsSuretyReplaced}
                  onClick={(e) => {
                    e.preventDefault();

                    if (surety?.IsSuretyReplaced) {
                      setSuretyForReplacement(surety);
                      setShowSuretyReplaceModal(true);
                    }
                  }}
                >
                  <i className="fas fa-random"></i>
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  useEffect(() => {
    getLoanDetails();
    getSuretyDetails();
    CheckRepaymentCriteria();
  }, []);

  useEffect(() => {
    if (!showSuretyReplaceModal) {
      setError({});
    }
  }, [showSuretyReplaceModal]);

  if (loanDetails?.loanAmount === 0) {
    return null;
  }

  const isAdditionalLongTermLoan = [
    LoanTypeEnum.LONGTERM,
    LoanTypeEnum.ADDITIONALLONGTERM,
  ].includes(loanDetails.loanType);
  const colClassName = isAdditionalLongTermLoan
    ? "col-lg-3 col-md-6 col-sm-12"
    : "col-lg-4 col-md-6 col-sm-12";

  return (
    <div className="pb-3">
      <div className="col-12 p-0">
        <div className="row">
          <div className={`${colClassName}`}>
            <div className="form-group"></div>
            <label>Loan Amount</label>
            <InputForm
              placeholder={""}
              value={getFormattedCurrencyValue(
                loanDetails.loanAmount.toString()
              )}
              isDisabled={true}
              maxLength={30}
            />
          </div>
          {isAdditionalLongTermLoan && (
            <div className={`${colClassName}`}>
              <div className="form-group"></div>
              <label>Additional Loan Amount</label>
              <InputForm
                placeholder={""}
                value={getFormattedCurrencyValue(
                  loanDetails.additionalLoanAmount.toString()
                )}
                isDisabled={true}
                maxLength={30}
              />
            </div>
          )}
          <div className={`${colClassName}`}>
            <div className="form-group"></div>
            <label>Interest rate</label>
            <InputForm
              placeholder={""}
              value={loanDetails.ROI + " %"}
              isDisabled={true}
            />
          </div>
          {isAdditionalLongTermLoan && (
            <div className={`${colClassName}`}>
              <div className="form-group"></div>
              <label>Additional loan interest rate</label>
              <InputForm
                placeholder={""}
                value={loanDetails.aROI.toString() + " %"}
                isDisabled={true}
                maxLength={30}
              />
            </div>
          )}
          <div className={`${colClassName}`}>
            <div className="form-group"></div>
            <label>Period of installments</label>
            <InputForm
              placeholder={""}
              value={loanDetails.loanTenure + " Months"}
              isDisabled={true}
            />
          </div>
        </div>
        <div className="row m-3 p-3 align-items-center">
          {isAdditionalLongTermLoan ? (
            <>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 table-graph-container">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <table className="table">
                        <tr>
                          <td className="tableData">Loan EMI: </td>
                          <td className="tableData">
                            <i className="fa fa-inr"></i>
                            {loanDetails.loanEmi != null &&
                              getFormattedCurrencyValue(
                                loanDetails.loanEmi.toString()
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td className="tableData">Pending Months: </td>
                          <td className="tableData">
                            {loanDetails.pendingMonths != null &&
                              getFormattedCurrencyValue(
                                loanDetails.pendingMonths.toString()
                              )}
                            {` Month${
                              loanDetails.pendingMonths > 1 ? "s" : ""
                            }`}
                          </td>
                        </tr>
                        <tr>
                          <td className="tableData">Balance Amount: </td>
                          <td className="tableData">
                            <i className="fa fa-inr"></i>
                            {loanDetails.balanceAmount != null &&
                              getFormattedCurrencyValue(
                                loanDetails.balanceAmount.toString()
                              )}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      {showGraph && <CanvasJSChart options={options1} />}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 table-graph-container">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <table className="table">
                        <tr>
                          <td className="tableData">Loan EMI: </td>
                          <td className="tableData">
                            <i className="fa fa-inr"></i>
                            {loanDetails.emiAmountAL != null &&
                              getFormattedCurrencyValue(
                                loanDetails.emiAmountAL.toString()
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td className="tableData">Pending Months: </td>
                          <td className="tableData">
                            {loanDetails.pendingMonthsAL != null &&
                              getFormattedCurrencyValue(
                                loanDetails.pendingMonthsAL.toString()
                              )}
                            {` Month${
                              loanDetails.pendingMonthsAL > 1 ? "s" : ""
                            }`}
                          </td>
                        </tr>
                        <tr>
                          <td className="tableData">Balance Amount: </td>
                          <td className="tableData">
                            <i className="fa fa-inr"></i>
                            {loanDetails.outstandingAmountAL != null &&
                              getFormattedCurrencyValue(
                                loanDetails.outstandingAmountAL.toString()
                              )}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 canv">
                      {showGraph && <CanvasJSChart options={options2} />}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="container-fluid">
                  <div className="row">
                    <div className="col"></div>
                    <div className="col">
                      <CanvasJSChart options={options2} />
                    </div>
                  </div>
                </div> */}
            </>
          ) : (
            <>
              <div className="col-lg-6 px-md-5">
                <table className="table">
                  <tr>
                    <td className="tableData">Loan EMI: </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {loanDetails.loanEmi != null &&
                        getFormattedCurrencyValue(
                          loanDetails.loanEmi.toString()
                        )}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Pending Months: </td>
                    <td className="tableData">
                      {loanDetails.pendingMonths != null &&
                        getFormattedCurrencyValue(
                          loanDetails.pendingMonths.toString()
                        )}
                      {` Month${loanDetails.pendingMonths > 1 ? "s" : ""}`}
                    </td>
                  </tr>
                  <tr>
                    <td className="tableData">Balance Amount: </td>
                    <td className="tableData">
                      <i className="fa fa-inr"></i>
                      {loanDetails.balanceAmount != null &&
                        getFormattedCurrencyValue(
                          loanDetails.balanceAmount.toString()
                        )}
                    </td>
                  </tr>
                </table>
              </div>

              <div className="col-lg-6 px-md-5">
                {showGraph && <CanvasJSChart options={options1} />}
              </div>
            </>
          )}
        </div>
        <div className="col-lg-12 p-0">
          <div className="route-title-container d-flex justify-content-center">
            <span className="route-title">Surety Details</span>
          </div>
          {/* <div className="row justify-content-center">
              <table className="table w-auto">
                <thead
                  style={{
                    backgroundColor: "#DB233A",
                    color: "white",
                  }}
                >
                  <tr>
                    <th className="tableData">Member No</th>
                    <th className="tableData">Member Name</th>
                    <th className="tableData">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {sureties.map((surety) => {
                    return (
                      <tr>
                        <td className="tableData">{surety?.MemberNo}</td>
                        <td className="tableData">{surety?.FullName}</td>
                        <td className="tableData d-flex justify-content-center">
                          <Tooltip title="replace">
                            <IconButton
                              aria-label="delete"
                              size="small"
                              color="info"
                              disabled={!surety?.IsSuretyReplaced}
                              onClick={(e) => {
                                e.preventDefault();

                                if (surety?.IsSuretyReplaced) {
                                  setSuretyForReplacement(surety);
                                  setShowSuretyReplaceModal(true);
                                }
                              }}
                            >
                              <i className="fas fa-random"></i>
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div> */}
          <div className="row">
            <div className="col-lg-12 mb-4">
              <DynamicGrid
                options={Options}
                data={dashboardData}
                columns={GridColumns}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end m-1">
            <ButtonComponent
              className="btn btn-submit"
              style={{
                marginLeft: 5,
                cursor: "pointer",
              }}
              icon={""}
              value={"Apply for Repayment"}

              onClick={() => {
                setRepaymentModal(true);
              }}
              disabled={!isSettlementButtonEnabled}
            />
            <ButtonComponent
              className="btn btn-dark"
              style={{
                marginLeft: 5,
                cursor: "pointer",
              }}
              icon={""}
              value={"Cancel"}
              onClick={() => {
                navigate(-1);
              }}
            />
          </div>
        </div>
      </div>

      <Modal
        centered
        show={showSuretyReplaceModal}
        onHide={() => {
          setShowSuretyReplaceModal(false);
          setSuretyForReplacement(null);
          setNewSuretyMemberNo("");
        }}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.75)" }}
      >
        <Modal.Header className="custom-modal-header" closeButton>
          <Modal.Title>New Surety</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div>
              <div className="form-group"></div>
              <label>Please enter member no.</label>
              <sup>*</sup>
            </div>
            <InputForm
              value={newSuretyMemberNo}
              placeholder={"Member Number"}
              type="text"
              maxlength={5}
              style={{
                width: "30%",
              }}
              onChange={(e) => {
                setNewSuretyMemberNo(e.target.value);
              }}
              onKeyDown={(evt) =>
                ["e", "E", "+", "-", ".", "v"].includes(evt.key) &&
                evt.preventDefault()
              }
            />
            {error[newSuretyMemberNo] && (
              <p style={{ color: "red" }}>{error[newSuretyMemberNo]}</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center">
            <div>
              <ButtonComponent
                className="btn btn-submit"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"Submit"}
                onClick={() => {
                  replaceSurety();
                }}
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        centered
        show={showRepaymentModal}
        onHide={() => {
          setRepaymentModal(false);
        }}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.75)" }}
      >
        <Modal.Header className="custom-modal-header" closeButton>
          <Modal.Title>Apply For Repayment?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="form-group">
              <label>
                Are you considering making a complete/partial Repayment of the
                loan amount?
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center">
            <div>
              <ButtonComponent
                className="btn btn-dark"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"Yes"}
                onClick={() => {
                  navigate("/LoanSettlementTabs", {
                    state: {
                      LoanRequestId: LoanRequestId,
                      LoanRepaymentId: 0,
                      Status: Status,
                      RepaymentAmount: RepaymentAmount,
                    },
                  });
                }}
              />
              <ButtonComponent
                className="btn btn-dark"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"No"}
                onClick={() => {
                  setRepaymentModal(false);
                }}
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LoanDetailsMemberView;
